import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import firebaseapi from "../../src/utils/firebaseapi";
import { DocumentData } from "firebase/firestore";
import useOnclickOutside from "react-cool-onclickoutside";
import { ReactComponent as GitHub } from "../assets/images/github.svg";
import { ReactComponent as Member } from "../assets/images/member.svg";
import { Tours, stepType } from "./Tours";
import SearchResults from "./SearchResults";

import { RootState } from "..";

const Wrapper = styled.div`
  display: flex;
  margin: 0 auto;
  height: 62px;
  background-color: #24292f;
  padding-left: 16px;
  align-items: center;
  width: 100%;
  @media screen and (max-width: 770px) {
    padding-left: 0;
  }
`;
const LogoContainer = styled(Link)`
  cursor: pointer;
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    path {
      stroke: #9a9b9d;
    }
  }
`;
const SearchForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 10px;
  max-width: 272px;
  height: auto;
  margin-top: 6px;
  background-color: #24292f;
  border: 1px solid #57606a;
  border-radius: 6px;
`;
const SearchInput = styled.input`
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  background: none;
  border: none;
  outline: none;
  &:focus {
    background-color: white;
  }
`;
const SearchBtn = styled.button`
  margin-right: 4px;
  width: 22px;
  height: 20px;
  color: #57606a;
  cursor: pointer;
  border: 1px solid #57606a;
  background-color: #24292f;
`;
const SearchWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 2px;
`;
const SearchContainer = styled.div`
  position: absolute;
  width: 270px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  background-color: white;
  border-radius: 0px 0px 6px 6px;
`;
const CategoryLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  width: 100%;
  margin-top: 7px;
  @media screen and (max-width: 770px) {
    display: none;
  }
`;
const Category = styled(Link)`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  color: white;
  margin-right: 30px;
  cursor: pointer;
  :hover {
    color: #9a9b9d;
  }
  @media screen and (max-width: 770px) {
    border-bottom: 1px solid #d0d7de;
    padding-bottom: 8px;
    padding-top: 8px;
    font-size: 14px;
    color: #d0d7de;
  }
`;

const CategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
const LeftContainer = styled.div``;
const RightContainer = styled.div`
  margin-right: 5px;
  display: flex;
  align-items: center;
`;

const MobileBar = styled.div`
  @media screen and (max-width: 770px) {
    display: block;
  }
`;
const ToggleBtn = styled.button`
  margin-left: 16px;
  height: 24px;
  width: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  box-sizing: border-box;
  @media screen and (min-width: 770px) {
    display: none;
  }
`;
const ToggleBtnLine = styled.div`
  width: 17px;
  height: 2px;
  background: #d0d7de;
`;
const MobileSidebar = styled.div`
  position: absolute;
  width: 100%;
  height: 250px;
  background-color: #24292f;
  top: 62px;
  z-index: 999;
`;
const MobileLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
const CloseBtn = styled.button`
  font-size: 20px;
  background-color: #24292f;
  border: none;
  margin-top: 3px;
  color: white;
  cursor: pointer;
  &:hover {
    color: #9a9b9d;
  }
`;
const MobileTourWrapper = styled.div`
  @media screen and (max-width: 770px) {
    display: none;
  }
`;

const Header = () => {
  const currentPage = useLocation();
  const [page, setPage] = useState("");
  let navigate = useNavigate();
  const userInfo = useSelector((state: RootState) => state);
  const [searchResults, setSearchResults] = useState<DocumentData>();
  const [showSidebar, setShowSidebar] = useState(false);
  const clickhandler = () => {
    setShowSidebar(true);
  };

  useEffect(() => {
    setPage(currentPage.pathname);
  }, [currentPage]);

  const memberHandler = () => {
    if (userInfo.user.user_id) {
      navigate("/member");
    } else {
      navigate("/signin");
    }
  };

  const [searchName, setSearchName] = useState("");
  const [expanded, setExpanded] = useState(false);
  function expand() {
    setExpanded(true);
  }
  const ref = useOnclickOutside(() => {
    setExpanded(false);
    setShowSidebar(false);
  });

  const getSearchName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchName(e.target.value);
  };
  const getSearchResults = () => {
    setSearchName("");
    firebaseapi.searchUserByName(searchName).then((res) => {
      if (res) {
        expand();
        setSearchResults(res);
      }
    });
  };

  return (
    <>
      <Wrapper>
        <MobileBar>
          <ToggleBtn onClick={clickhandler}>
            <ToggleBtnLine />
            <ToggleBtnLine />
            <ToggleBtnLine />
          </ToggleBtn>
        </MobileBar>
        {showSidebar && (
          <MobileSidebar ref={ref}>
            <MobileLinkContainer>
              <Category to="branches" id="branches">
                Branches
              </Category>
              <Category to="issues" id="issues">
                Issues
              </Category>
              <MobileTourWrapper>
                <Category as="div" id="docs">
                  <Tours stepType={stepType} page={page} />
                </Category>
              </MobileTourWrapper>
              <Category to="repo" id="repo">
                Repo
              </Category>
              <Category as="div" onClick={memberHandler}>
                Member
              </Category>
              <CloseBtn
                onClick={() => {
                  setShowSidebar(false);
                }}
              >
                &times;
              </CloseBtn>
            </MobileLinkContainer>
          </MobileSidebar>
        )}
        <LogoContainer to="/">
          <GitHub stroke="#FFF" />
        </LogoContainer>
        <SearchForm>
          <SearchWrapper id="searchUser">
            <SearchInput
              placeholder="Enter name to search user..."
              onChange={getSearchName}
              value={searchName}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  getSearchResults();
                }
              }}
            />
            <SearchBtn onClick={getSearchResults}>/</SearchBtn>
          </SearchWrapper>
          {expanded && (
            <SearchContainer ref={ref}>
              <SearchResults searchResults={searchResults} />
            </SearchContainer>
          )}
        </SearchForm>
        <CategoryLinks>
          <CategoryContainer>
            <LeftContainer>
              <Category to="branches" id="branches">
                Branches
              </Category>
              <Category to="issues" id="issues">
                Issues
              </Category>
            </LeftContainer>
            <RightContainer>
              <Category as="div" id="docs">
                <Tours stepType={stepType} page={page} />
              </Category>
              <Category to="repo" id="repo">
                Repo
              </Category>
              <Category as="div" onClick={memberHandler}>
                <Member />
              </Category>
            </RightContainer>
          </CategoryContainer>
        </CategoryLinks>
      </Wrapper>
    </>
  );
};

export default Header;
